import React, { Component } from "react";
import PropTypes from "prop-types";
import { connect } from "react-redux";
import updateDisplay from "../../../actions/display";
import RunsheetTable from "./RunsheetTable";
import RunsheetCalendar from "./RunsheetCalendar";

class RunsheetList extends Component {
  handleDisplayChange = display => {
    this.props.updateDisplay(display);
  };

  render() {
    const { display, match: { path } } = this.props;

    if (display === "TABLE") {
      return (
        <RunsheetTable
          path={path}
          handleDisplayChange={this.handleDisplayChange}
        />
      );
    }
    return <RunsheetCalendar handleDisplayChange={this.handleDisplayChange} />;
  }
}
RunsheetList.propTypes = {
  match: PropTypes.shape({
    path: PropTypes.string
  }).isRequired,
  display: PropTypes.string.isRequired,
  updateDisplay: PropTypes.func.isRequired
};

const mapStateToProps = state => ({ display: state.display });

export default connect(mapStateToProps, { updateDisplay })(RunsheetList);



// WEBPACK FOOTER //
// ./src/components/runsheets/list/RunsheetList.js